import { logChange } from './changeLogger';

export const logHetznerShopIntegration = () => {
  const alreadyLogged = localStorage.getItem('hetzner-shop-logged');
  
  if (!alreadyLogged) {
    logChange(
      'iso27001',
      'Hetzner Shop in ISO 27001 integriert',
      'E-Commerce Shop auf Hetzner Hochsicherheitsserver wurde in Asset-Verzeichnis, Risikoregister und Lieferantenliste aufgenommen',
      {
        neueAssets: [
          'E-Commerce Shop (Hetzner)',
          'Shop-Datenbank (Hetzner)',
          'Payment-System (Shop)'
        ],
        neueRisiken: [
          'R016: Shop-Server Ausfall',
          'R017: Payment-Daten Kompromittierung',
          'R018: Shop-DDoS-Angriff',
          'R019: Kundendaten-Leak im Shop',
          'R020: Hetzner Infrastruktur-Ausfall'
        ],
        neueLieferanten: [
          'Hetzner Online GmbH - Hochsicherheitsserver'
        ],
        sicherheitsmerkmale: [
          'ISO 27001 zertifiziert',
          'DDoS-Schutz',
          '99.9% SLA',
          'Rechenzentrum Deutschland',
          'PCI-DSS konforme Payment-Integration'
        ]
      }
    );
    
    localStorage.setItem('hetzner-shop-logged', 'true');
  }
};
